import { useState } from 'react'
import { useOnboardingStorage } from '../onboarding.store'
import { EnhancedPaper } from 'summon-ui'
import { useTranslation } from 'summon-ui/intl'
import { Button, Divider, Group, Modal, Stack, Text, Title, Box } from 'summon-ui/mantine'
import useQuestsCategories from '@features/quests/hooks/useQuestCategories'
import QuestCategoryDetailsView from '@features/quests/views/QuestCategoryDetails.view'

const IntroQuestsView = () => {
  const t = useTranslation()
  const nextStep = useOnboardingStorage((state) => state.nextStep)
  const [isSkipModalOpen, setIsSkipModalOpen] = useState(false)
  const skip = () => {
    setIsSkipModalOpen(true)
  }
  const { featuredCategory } = useQuestsCategories({})

  return (
    <Box>
      <Title pb={20}>{t('Complete Intro Quests')}</Title>
      <div className='w-full max-h-[80vh] overflow-y-scroll no-scrollbar'>
        {featuredCategory && <QuestCategoryDetailsView category={featuredCategory.id} />}
      </div>
      <EnhancedPaper withBg w='100%' className='md:absolute fixed bottom-0 left-0'>
        <Divider />
        <Group justify='flex-end' align='center' px='lg' py='md' h='100%'>
          <Button onClick={skip}>{t('Continue')}</Button>
        </Group>
      </EnhancedPaper>

      <Modal opened={isSkipModalOpen} onClose={() => setIsSkipModalOpen(false)} maw={340} radius='md'>
        <Stack gap='xs' p='sm'>
          <Title order={2}>{t('Continue to Mint')}</Title>
          <Text>
            {t(
              'You can dive back into your quests whenever you feel like it, right from the ‘Quests’ section in the menu.'
            )}
          </Text>

          <Group justify='space-between' mt='sm'>
            <Button variant='outline' onClick={() => setIsSkipModalOpen(false)}>
              {t('Cancel')}
            </Button>
            <Button onClick={nextStep}>{t('Continue')}</Button>
          </Group>
        </Stack>
      </Modal>
    </Box>
  )
}

export default IntroQuestsView
